/* Galleria Frasi — filtri della pagina "Trova l'ispirazione".

   La griglia e' unica e le card portano la categoria addosso (data-gf-cat):
   filtrare e' nascondere, non ricostruire, cosi' le immagini gia' scaricate
   non vengono richieste una seconda volta passando da un filtro all'altro.

   Le categorie sono i blocchi "Categoria" della sezione: qui non c'e' nessun
   elenco scritto a mano, chi aggiunge una categoria dall'editor si ritrova la
   pillola in pagina senza toccare questo file. */
(function () {
  const TUTTE = 'tutte';

  function init(root) {
    const filtri = root.querySelectorAll('[data-gf-filter]');
    if (!filtri.length) return;

    const cards = root.querySelectorAll('[data-gf-cat]');
    const note = root.querySelectorAll('[data-gf-note]');
    const vuoto = root.querySelector('[data-gf-empty]');

    function applica(categoria) {
      let visibili = 0;
      cards.forEach((card) => {
        const dentro = categoria === TUTTE || card.dataset.gfCat === categoria;
        card.classList.toggle('is-filtered-out', !dentro);
        if (dentro) visibili += 1;
      });

      // la riga descrittiva appartiene alla categoria: si vede solo con la sua
      note.forEach((n) => {
        n.classList.toggle('is-filtered-out', n.dataset.gfNote !== categoria);
      });

      if (vuoto) vuoto.classList.toggle('gg-gf-empty--visibile', visibili === 0);
    }

    filtri.forEach((btn) => {
      btn.addEventListener('click', () => {
        filtri.forEach((altro) => {
          const attivo = altro === btn;
          altro.classList.toggle('is-active', attivo);
          altro.setAttribute('aria-pressed', attivo ? 'true' : 'false');
        });
        applica(btn.dataset.gfFilter);
      });
    });

    applica(TUTTE);
  }

  /* Zoom (cliente 08/08, secondo giro): la card non porta piu' al prodotto,
     e' lei stessa il trigger del lightbox (data-gf-zoom sta sulla card con
     foto; le card solo-frase non ce l'hanno e restano inerti). E' un div con
     role="button", quindi Enter e Spazio vanno gestiti a mano. */
  function initZoom(root) {
    const box = root.querySelector('[data-gf-lightbox]');
    if (!box) return;
    const img = box.querySelector('[data-gf-lightbox-img]');

    function chiudi() {
      box.hidden = true;
      img.removeAttribute('src');
      document.body.style.overflow = '';
    }

    root.querySelectorAll('[data-gf-zoom]').forEach((card) => {
      function apri() {
        img.src = card.dataset.gfFull;
        img.alt = card.dataset.gfAlt || '';
        box.hidden = false;
        document.body.style.overflow = 'hidden';
      }

      card.addEventListener('click', apri);
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); // lo Spazio non deve scrollare la pagina
          apri();
        }
      });
    });

    box.addEventListener('click', (e) => {
      // chiude su sfondo e su X, non sull'immagine
      if (e.target !== img) chiudi();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !box.hidden) chiudi();
    });
  }

  /* CTA fissa: sopra il footer si inverte (stessa logica della GgFrasiStickyCta
     del configuratore — sovrapposizione vera dei riquadri, non un'altezza
     indovinata). */
  function initSticky(root) {
    const btn = root.querySelector('[data-gf-sticky]');
    const footer = document.querySelector('footer');
    if (!btn || !footer) return;

    function check() {
      const b = btn.getBoundingClientRect();
      const f = footer.getBoundingClientRect();
      btn.classList.toggle('is-on-footer', f.top < b.bottom && f.bottom > b.top);
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-gg-galleria-frasi]').forEach((root) => {
      init(root);
      initZoom(root);
      initSticky(root);
    });
  });
})();
